module.exports = __webpack_public_path__ + "channel_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-slider/assets/channel_1.png
// module id = 1127
// module chunks = 10